export function numberAfterDotCounter(number: number) {
    if (!number) {
        return number;
    }
    const count = number.toString().match(/\.(\d+)/)?.[1].length;
    const str = number.toString().split(".");

    if (count && count >= 1 && str[1][0] !== "0") {
        return Number.parseFloat(number.toFixed(1));
    } else {
        return Number.parseFloat(number.toFixed(0));
    }
}
